var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-edit';
                    var viewUrl = 'sprite.svg#view-icon-edit';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?icon-edit#icon-edit';
                            viewUrl = 'sprite.svg?icon-edit#view-icon-edit';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 16.9 16.9',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };